import {
  faPen,
  faComments,
  faTimes,
  faFileCircleCheck, faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';
import useAuthz from 'hooks/useAuthz';
import React, { useEffect, useState } from 'react';
import { URL_API } from '../../utils/globalConfig';
import axios from 'axios';
import MyDialog from '../Layout/MyDialog';
import { useAlert } from 'react-alert';
import { PLANIFICATION_STATUS, PROFIL } from '../../constants/enum';
import { logError } from '../Utils/FormatData';
import ModalViewTchats from '../../views/Dossier/ModalViewTchats';
import ModalViewContract from '../../views/Dossier/ModalViewContract';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ModalPlanificationTchat from '../../views/Planification/ModalPlanificationTchat';
import { dateFormatter } from '../../utils/dateHelper';

const ActionsPlanificationRenderer = (props) => {
  const { setReloadDatas, setSelectedPlanification, setOpenModal, setPlanificationMode} = props;
  const alert = useAlert();
  const [authz, user, profil] = useAuthz();
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openTchatModal, setOpenTchatModal] = useState(false);
  const [openPlanificationTchatModal, setOpenPlanificationTchatModal] = useState(false);
  const [openContractModal, setOpenContractModal] = useState(false);
  const [contractId, setContractId] = useState(null);
  const [unreadRequestPassMessages, setUnreadRequestPassMessages] = useState(false);
  const [unreadPlanificationMessages, setUnreadPlanificationMessages] = useState(false);

  const onDeleteBtnClick = () => {
    setOpenDeleteDialog(true);
  };
  const onContractBtnClick = () => {
    setOpenContractModal(true);
  };
  const onTchatBtnClick = () => {
    setOpenTchatModal(true);
  };
  const onTchatPlanificationBtnClick = () => {
    setOpenPlanificationTchatModal(true);
  }
  const onEditBtnClick = () => {
    setSelectedPlanification(props.data);
    setPlanificationMode(PLANIFICATION_STATUS.AVAILABLE);
    setOpenModal(true);
  }
  const onEditUnavailableBtnClick = () => {
    setSelectedPlanification(props.data);
    setPlanificationMode(PLANIFICATION_STATUS.UNAVAILABLE);
    setOpenModal(true);
  }
  const onConfirmationModalClose = (value) => {
    if (value) {
      apiDeletePlanification();
    }
  };

  useEffect(() => {
    if (props.data.dossier_id) {
      apiGetContract();
      apiGetUnreadRequestPassMessages();
      apiGetUnreadPlanificationMessages();
    }
  }, []);

  const apiGetContract = () => {
    axios({
      method: 'get',
      url: URL_API + '/demande-passage/verifier-accords-passage',
      params: { planificationId: props.data.id },
    })
    .then((response) => {
      setContractId(response.data);
    })
    .catch((error) => {
      logError(alert, error);
    });
  };

  const apiDeletePlanification = () => {
    // par défaut, on notifie tous le monde
    let recipientType = [PROFIL.CLIENT, PROFIL.INTERVENANT, PROFIL.GESTIONNAIRE, PROFIL.ADMINISTRATEUR];
    let deletedBy = '';

    if (profil.profil === PROFIL.CLIENT) {
      recipientType = [PROFIL.INTERVENANT, PROFIL.GESTIONNAIRE, PROFIL.ADMINISTRATEUR];
      deletedBy = props.data.dossier.metadata.complementIdentite.mandataire.transporteur === user.raison_sociale ? 'par le mandataire.' : 'par le client.';
    }

    if (profil.profil === PROFIL.GESTIONNAIRE || profil.profil === PROFIL.ADMINISTRATEUR) {
      recipientType = [PROFIL.CLIENT, PROFIL.INTERVENANT];
      deletedBy = 'par le gestionnaire.';
    }

    const formattedDate = dateFormatter(props.data.metadata.startDate);

    let title = `GATE : Demande de passage supprimée pour le dossier [N°${props.data.dossier_id}]`;
    let message = `La demande de passage ${formattedDate} pour le dossier [N°${props.data.dossier_id}] a été supprimée ${deletedBy}`;

    if (props.data.dossier_id) {
      axios({
        method: 'post',
        url: URL_API + '/planification/delete',
        data: {
          recipientType: recipientType,
          title: title,
          message: message,
          planificationId: props.data.id,
        },
        params: { userAction: user.user_id, requestPassId: props.data.dossier_id },
      })
      .then(() => {
        alert.removeAll();
        alert.success(`L'élément a bien été supprimé`);
        setReloadDatas(true);
        setOpenDeleteDialog(false);
      })
      .catch((error) => {
        logError(alert, error);
      });
    }
  };

  const apiGetUnreadRequestPassMessages = () => {
    if (props.data.type === PLANIFICATION_STATUS.UNAVAILABLE) return;
    axios({
        method: 'get',
        url: URL_API + '/messagerie/dossier-messages-non-lus',
        params: { requestPassId: props.data.dossier.id, userAction: user.user_id }
    })
    .then((response) => {
        setUnreadRequestPassMessages(response.data);
    })
    .catch((error) => {
        logError(alert, error);
    });
  }

    const apiGetUnreadPlanificationMessages = () => {
      if (props.data.type === PLANIFICATION_STATUS.UNAVAILABLE) return;
      axios({
          method: 'get',
          url: URL_API + '/messagerie/planification-messages-non-lus',
          params: { planificationId: props.data.id, userAction: user.user_id }
      })
      .then((response) => {
          setUnreadPlanificationMessages(response.data);
      })
      .catch((error) => {
        logError(alert, error);
      });
  }

  const adminBtnTemplate = () => {
    return (
      <>
        <>
          <div className='buttons-request-table' style={{ backgroundColor: '#c02a31' }} title='Supprimer'
               onClick={onDeleteBtnClick}>
            <FontAwesomeIcon icon={faTrashAlt} style={{ color: '#ffffff', height: '12px' }} />
          </div>
        </>
        <>
        </>
      </>
    )
        ;
  };
  return (
      <div style={{ display: 'flex' }}>
        {
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {props.data.type !== PLANIFICATION_STATUS.UNAVAILABLE &&
                <>
                  <div className='buttons-request-table' style={{ backgroundColor: '#bb0060c4' }} title='Modifier'
                       onClick={onEditBtnClick}>
                    <FontAwesomeIcon icon={faPen} style={{ color: '#ffffff', height: '12px' }} />
                  </div>

                  {(profil.profil === 1 || profil.profil === 2) &&
                      adminBtnTemplate()
                  }

                  <div className='buttons-request-table' style={{ backgroundColor: '#a4c745' }} title='Tchat dossier'
                       onClick={onTchatBtnClick}>
                      {unreadRequestPassMessages &&
                          <div id='num-message-dossier' />
                      }
                    <FontAwesomeIcon icon={faComments} style={{ color: '#ffffff', height: '12px' }} />
                  </div>

                  <div className='buttons-request-table' style={{ backgroundColor: '#C83B83FF' }} title='Tchat planification'
                       onClick={onTchatPlanificationBtnClick}>
                      {unreadPlanificationMessages &&
                            <div id='num-message-planification' />
                      }
                    <FontAwesomeIcon icon={faComments} style={{ color: '#ffffff', height: '12px' }} />
                  </div>

                  {(props.data.metadata.status === PLANIFICATION_STATUS.AGREEMENT_ISSUED && (profil.profil === 1 || profil.profil === 2 || (contractId && (profil.profil === 3 || profil.profil === 5)))) &&
                      <>
                        <div className='buttons-request-table' style={{ backgroundColor: '#0094ca' }}
                             title='Accords de passage'
                             onClick={onContractBtnClick}>
                          <FontAwesomeIcon icon={faFileCircleCheck} style={{ color: '#ffffff', height: '12px' }} />
                        </div>
                      </>
                  }

                  {props.data.metadata.status=== PLANIFICATION_STATUS.NEW &&
                      <>
                        {profil.profil === 5 &&
                            <div className='buttons-request-table' style={{ backgroundColor: '#c02a31' }} title='Supprimer'
                                 onClick={onDeleteBtnClick}>
                              <FontAwesomeIcon icon={faTrashAlt} style={{ color: '#ffffff', height: '12px' }} />
                            </div>
                        }
                      </>
                  }
                </>
            }

            {props.data.type === PLANIFICATION_STATUS.UNAVAILABLE &&
                <>
                  <div className='buttons-request-table' style={{ backgroundColor: '#bb0060c4' }} title='Modifier'
                       onClick={onEditUnavailableBtnClick}>
                    <FontAwesomeIcon icon={faPen} style={{ color: '#ffffff', height: '12px' }} />
                  </div>

                  {(profil.profil === 1 || profil.profil === 2) &&
                      <div className='buttons-request-table' style={{ backgroundColor: '#c02a31' }} title='Supprimer'
                           onClick={onDeleteBtnClick}>
                        <FontAwesomeIcon icon={faTrashAlt} style={{ color: '#ffffff', height: '12px' }} />
                      </div>
                  }
                </>
            }
          </div>
        }

        {(profil.profil === 1 || profil.profil === 2 || profil.profil === 5) &&
            <>
              <MyDialog
                  open={openDeleteDialog}
                  handleClose={setOpenDeleteDialog}
                  title={`Voulez-vous vraiment supprimer cette période de passage ?`}
            content={'Cette action est irréversible'}
            dialog={onConfirmationModalClose}
          />
        </>
      }

      {props.data.dossier &&
        <>
          <ModalViewTchats openModal={openTchatModal} setOpenModal={setOpenTchatModal} setNeedReload={setReloadDatas} color={'#0094ca'} user={user} profil={profil} dossier={props.data.dossier} />
        </>
      }

      {props.data.id &&
        <>
          <ModalPlanificationTchat openModal={openPlanificationTchatModal} setOpenModal={setOpenPlanificationTchatModal} setNeedReload={setReloadDatas} color={'#0094ca'} user={user} profil={profil} planification={props.data} />
        </>
      }

      {props.data.dossier &&
        <>
          <ModalViewContract openModal={openContractModal} setOpenModal={setOpenContractModal} color={'#0094ca'} user={user} profil={profil} dossier={props.data.dossier} contractId={contractId} planification={props.data} />
        </>
      }
    </div>
  );

};

export default ActionsPlanificationRenderer;
